import { Box, Button, Typography } from '@mui/material';
import { HomepageProductHighlight } from '../Data';

import { tss } from 'tss-react/mui';
import { Link } from 'react-router-dom';
const IMAGE_SIZE = 250;

const HighlightProductCard: React.FC<{ data: HomepageProductHighlight }> = ({
  data
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <img
        src={data.img}
        width={IMAGE_SIZE}
        height={IMAGE_SIZE}
        alt={`Product highlight ${data.title}`}
      />
      <Typography variant="h3">{data.title}</Typography>
      <Typography variant="body1" style={{ flexGrow: 1 }}>
        {data.tag}
      </Typography>
      <Button
        component={Link}
        to={data.button.link}
        variant="contained"
        sx={{
          textTransform: 'uppercase',
          mx: 'auto'
        }}
      >
        {data.button.title}
      </Button>
    </Box>
  );
};

export default HighlightProductCard;
const useStyles = tss.create(({ theme }) => ({
  root: {
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    minWidth: '100%',
    background: 'white',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
  }
}));
